import React, {useEffect, useState} from "react";
import classNames from "classnames";


const timerToChange = 5000;

export default function Indicators (props) {
  const {count, activeIndex, updateActiveIndex} = props;
  const [{start, end}, setGrowing] = useState({start: null, end: null});
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    setGrowing({start: +(new Date()), end: (+(new Date())) + timerToChange});
  }, [count, activeIndex]);

  useEffect(() => {
    let unmounted = false;

    function render () {
      if (unmounted) { return; }
      requestAnimationFrame(render);
      if (start === null || end === null) { return null; }
      const now = (+(new Date()));
      const newPercentage = Math.min((now - start) / (end - start), 1);
      if (newPercentage < 1) { setPercentage(newPercentage); }
      else {
        setPercentage(0);
        updateActiveIndex((activeIndex + 1) % count);
      }
    }
    render();

    return () => { unmounted = true; };
  }, [start, end]);

  // const percentage = ((+(new Date())) - start) / (end - start);

  const indicatorItems = [];
  for (let i = 0; i < count; i++) {
    indicatorItems.push(
      <div
        key={i}
        onClick={() => updateActiveIndex(i)}
        className="superbanner__indicators__item"
      >
        <div className="superbanner__indicators__growable" style={{width: activeIndex === i ? (percentage * 100) + "%" : 0}} />
      </div>
    );
  }

  return (
    <div className={classNames('superbanner__indicators', `superbanner__indicators--${count}`)}>{indicatorItems}</div>
  );
}



// WEBPACK FOOTER //
// ./src/Superbanner/Indicators.js